<template>
  <div>

   <label class="col-form-label font-weight-bold"> {{text}} </label>

    <select  v-model="newvalor" class="form-control p-3" :placeholder="placeholder" :disabled="disabled" :readonly="readonly">
      
      <option v-for="l in lista" :key="l.id" :value="l.desc" >{{l.desc}}</option>
      
      </select>
     

  </div>
</template>

<script>
export default {

 data(){
   return{
     newvalor : '',

     lista:[
        { 
          id : 1,
          desc : "2 Hates Horizontais",
          path_img : ""
           
        },
          { 
          id : 2,
          desc : "2 Hates Verticais",
          path_img : ""
           
        },
          { 
          id : 3,
          desc : "3 Hates Horizontais",
          path_img : ""
           
        },
          { 
          id : 4,
          desc : "3 Hates Verticais",
          path_img : ""
           
        },
          { 
          id : 5,
          desc : "Hates Central",
          path_img : ""
           
        },
          { 
          id : 6,
          desc : "5 Hates",
          path_img : ""
           
        },
        { 
          id : 7,
          desc : "4 Hates",
          path_img : ""
           
        },

       
     ]
        
        
   }
 } ,

props: {
  text : String,
  tipo : String,
  placeholder : '',
  readonly : String,
  disabled : String
},
watch : {
  
 newvalor(val){       
  
  //  this.$emit('eventInput', val)

   }
}

}
</script>

<style >
.flex{
 
 flex-direction: column;
   
}

.col-form-label {
    padding-top: calc(0.375rem + 1px);
    padding-bottom: calc(0.375rem + 1px);
    margin-bottom: 0;
    font-size: inherit;
    line-height: 1.5;
}
.form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: var(--inputColor);
    background-color: var(--white);
    background-clip: padding-box;
    border: 1px solid var(--greyBtn);
    border-radius: 0.35rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}



.form-control:focus {
    color: var(--inputColor);
    background-color: var(--white);
    border-color: var(--borderInput);
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgb(9 243 107 / 25%);
}

.form-control:focus {
    animation: pulseGreenShadow 0.5s ease-in-out infinite alternate-reverse;
}



</style>
